import Styles from './meio.module.css'
import banner from '../imgs/home.jpg'

function Meio(){
    return(
        <div className= {Styles.tudo}>    
            <img src={banner}></img>
        </div> 
    
    )
}
export default Meio